import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icon_17.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "wh-20",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "fz-14 color-primary ml-8" }, "刷新", -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]


	
	
export default /*#__PURE__*/_defineComponent({
  __name: 'ListRefresh',
  emits: ["change"],
  setup(__props, { emit: __emit }) {

	const emits = __emit;
	
	const Operate = () => {
		emits("change");
	};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex-row-center-start pl-20 h-36 pointer",
    onClick: Operate
  }, _hoisted_3))
}
}

})